import { JSX } from 'react';

// components
import { ClientVideoHero } from './or-video-hero.client';

// types
import { parseImageFromCMS } from '@/lib/contentstack-sdk/utils/parseHelpers';
import { IOrVideoHeroCsProps } from './or-video-hero.types';

export const OrVideoHeroCS = ({ block }: IOrVideoHeroCsProps): JSX.Element => {
  const {
    hero_description: description,
    title,
    header_image,
    hero_video,
  } = block;

  return (
    <ClientVideoHero
      title={title}
      description={description}
      image={parseImageFromCMS(header_image)!}
      videoUrl={hero_video?.url}
    />
  );
};
